import { request } from "./request";

export const FRONTEND_RELEASE_ACTIONS = {
  ENABLE: "enable",
  DISABLE: "disable",
};

export default class FrontendReleasesAPI {
  /**
   * Enable or disable the v2 frontend release for a set of whitelabel hosts.
   * The response separates updated hosts from blacklisted hosts that were
   * filtered out.
   * @param {Object} data - { hosts: string[], action: "enable" | "disable" }
   */
  static updateConfiguration({ hosts, action }) {
    return request({
      url: "/api/v1/admin/frontend-releases/configuration",
      method: "POST",
      data: { hosts, action },
    });
  }
}
